import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

import "./event_about.css";

const EventAbout = () => {
    const [memberCount, setMemberCount] = useState(0);
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const sectionElement = sectionRef.current;

        if (!sectionElement) {
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setShouldAnimate(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.35 }
        );

        observer.observe(sectionElement);

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!shouldAnimate) {
            return undefined;
        }

        const animationDuration = 1800;
        const targetValue = 5000;
        let animationFrameId;
        let animationStartTime;

        const animateCount = (timestamp) => {
            if (!animationStartTime) {
                animationStartTime = timestamp;
            }

            const elapsedTime = timestamp - animationStartTime;
            const progress = Math.min(elapsedTime / animationDuration, 1);
            const easedProgress = 1 - Math.pow(1 - progress, 3);
            const nextValue = Math.floor(targetValue * easedProgress);

            setMemberCount(nextValue);

            if (progress < 1) {
                animationFrameId = window.requestAnimationFrame(animateCount);
            }
        };

        animationFrameId = window.requestAnimationFrame(animateCount);

        return () => window.cancelAnimationFrame(animationFrameId);
    }, [shouldAnimate]);

    return (
        <section id="event_about_section" ref={sectionRef}>
            <div id="event_about_nmbrs_div">
                <h1 id="member_nmbr">{memberCount.toLocaleString()}+</h1>
                <p id="member_txt">Executive Members</p>
            </div>

            <div id="event_about_txt_div">
                <h1 id="event_about_hdng">About PropTech Club</h1>

                <p id="event_about_txt">
                    PropTech Club is a curated network of real estate stakeholders focused on
                    collaboration, innovation, and growth.
                </p>
                <p id="event_about_txt">
                    It is designed for individuals and organisations actively involved in
                    shaping the industry - not observing it.
                </p>
                <p id="event_about_txt">
                    Through structured interactions, closed-door sessions, and strategic
                    alignment, the club enables meaningful conversations that lead to real
                    outcomes.
                </p>

                <h5 id="event_about_highlight">Exclusive Member Benefits</h5>

                <span className="points">
                    <FaCheckCircle style={{ color: "#312FB8", fontSize: "17px", marginRight: "7px" }} />
                    Access to a curated network of decision-makers
                </span>
                <span className="points">
                    <FaCheckCircle style={{ color: "#312FB8", fontSize: "17px", marginRight: "7px" }} />
                    Private meetups and closed-door discussions
                </span>
                <span className="points">
                    <FaCheckCircle style={{ color: "#312FB8", fontSize: "17px", marginRight: "7px" }} />
                    Collaboration opportunities across projects and investments
                </span>
                <span className="points">
                    <FaCheckCircle style={{ color: "#312FB8", fontSize: "17px", marginRight: "7px" }} />
                    Direct exposure to industry insights and evolving trends
                </span>
                <span className="points">
                    <FaCheckCircle style={{ color: "#312FB8", fontSize: "17px", marginRight: "7px" }} />
                    Participation in a structured real estate ecosystem
                </span>

                <Link id="event_about_join_btn" to="/membership">
                    Join 5000+ Active Members
                </Link>
            </div>
        </section>
    );
};

export default EventAbout;
